// extracted by mini-css-extract-plugin
export default {"banner":"AppBanner_banner__WKvsM","banner_img":"AppBanner_banner_img__8Z8Br"};